import {
  Autocomplete,
  Box,
  Checkbox,
  Chip,
  CircularProgress,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { LoadingButton } from "@mui/lab";
import moment from "moment-timezone";
import styles from "./style";
import CustomInput from "../../../../components/CustomInput";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import PayrollEmployeeList from "./payrollEmployeeList";

function CreatePayrollPage({
  loading,
  departmentData,
  SearchEmployee,
  employeeData,
  submitPayroll,
  data,
  from,
  handleUpdatePayroll,
  handleDeleteEmployee,
  DepartmentPayroll,
  depData,
  empData,
}) {
  const [fromDate, setFromDate] = useState(
    from === "Edit" ? moment(data?.start) : moment().subtract(1, "day")
  );
  const [toDate, setToDate] = useState(
    from === "Edit" ? moment(data?.end).utc() : moment().subtract(1, "day")
  );
  const [selectedOptions, setSelectedOptions] = useState(
    from === "Edit" ? data?.employeeDetails : []
  );
  const [frequency, setFrequency] = useState(
    from === "Edit" ? data?.frequency : ""
  );
  const [paymentMethod, setPaymentMethod] = useState(
    from === "Edit" ? data?.paymentMethod : ""
  );
  const [department, setDepartment] = useState(
    from === "Edit" ? data?.department : ""
  );
  const [allEmp, setAllEmp] = useState("");
  const [payrollName, setPayrollName] = useState(from === "Edit" ? data?.name || "" : "");
  const [isUpdated, setisUpdated] = useState(false);
  const [payrollNameError, setPayrollNameError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [filteredDepData, setFilteredDepData] = useState(depData || []);
  const [deletedEmployeeIds, setDeletedEmployeeIds] = useState(new Set());

  useEffect(() => {
    if (depData && depData.length > 0) {
      setFilteredDepData(prev => {
        const existingIds = new Set(prev.map(emp => emp._id));
        const newEmployees = depData.filter(emp => 
          !existingIds.has(emp._id) && !deletedEmployeeIds.has(emp._id)
        );
        return [...prev, ...newEmployees];
      });
    } else if (depData && depData.length === 0) {
      // If depData is empty array, reset filteredDepData but keep deleted employees filtered out
      setFilteredDepData(prev => prev.filter(emp => !deletedEmployeeIds.has(emp._id)));
    }
  }, [depData, deletedEmployeeIds]);

  const calculateDates = (freq) => {
    const today = moment();
    let start = today.clone();
    let end = today.clone();
    if (freq === "Weekly") {
      start = today.clone().subtract(6, "days");
      end = today.clone();
    } else if (freq === "Monthly") {
      start = today.clone().subtract(1, "month").startOf("month");
      end = today.clone().subtract(1, "month").endOf("month");
    } else if (freq === "Fortnight") {
      start = today.clone().subtract(13, "days");
      end = today.clone();
    } else if (freq === "Custom" && from === "Edit") {
      start = moment(data?.start).utc().startOf("day");
      end = moment(data?.end).utc().startOf("day");
    }
    setFromDate(start);
    setToDate(end);
  };

  useEffect(() => {
    if (frequency && !(from === "Edit" && data?.start && data?.end)) {
      calculateDates(frequency);
    }
  }, [frequency]);

  useEffect(() => {
    if (from === "Edit" && data?.employeeDetails?.length && employeeData?.length) {
      const matchedEmployees = employeeData.filter(emp =>
        data.employeeDetails.some(sel => sel._id === emp._id)
      );
      setSelectedOptions(matchedEmployees);
    }
  }, [from, data, employeeData]);


  const handleDepartmentChange = (e) => {
    const selectedDept = e.target.value;
    setDepartment(selectedDept);
    let departmentEmployees = [];
    if (selectedDept === "All") {
      departmentEmployees = empData;
    } else {
      departmentEmployees = empData.filter(
        (emp) => emp.personalInfo.department === selectedDept
      );
    }

    const updatedOptions = [...selectedOptions, ...departmentEmployees].reduce(
      (acc, emp) => {
        if (!acc.some((existing) => existing._id === emp._id)) {
          acc.push(emp);
        }
        return acc;
      },
      []
    );
    setSelectedOptions(updatedOptions);
  };

  const handleChange = (event, newValue) => {
    if (from === "Edit") {
      const preservedEmployees = employeeData.filter(emp =>
        existingEmployees.includes(emp._id)
      );

      const updatedList = [
        ...preservedEmployees,
        ...newValue.filter(emp => !existingEmployees.includes(emp._id))
      ];

      setSelectedOptions(updatedList);
      setisUpdated(true);
    } else {
      setSelectedOptions(newValue);
    }
  };
  const handleDelete = (id, action) => {
    if (from === "Edit") {
      handleDeleteEmployee(data?._id, action, id);
    } else {
      setDeletedEmployeeIds(prev => new Set([...prev, id]));
      setSelectedOptions(
        selectedOptions.filter((selected) => selected._id !== id)
      );
      setFilteredDepData(
        filteredDepData.filter((emp) => emp._id !== id)
      );
    }
  };

  const removeEmployeesByName = (emails = []) => {
    console.log('🔍 ========== removeEmployeesByEmail called ==========');
    console.log('📧 Emails to remove:', emails);
    console.log('📋 Current selectedOptions count:', selectedOptions.length);
    console.log('📋 Selected employees:', selectedOptions.map(emp => ({
      _id: emp._id,
      email: emp.personalInfo?.email || emp.email
    })));
    
    const shouldRemoveEmployee = (employee) => {
      const email = (employee.personalInfo?.email || employee.email || '').toLowerCase().trim();
      
      // Check email match (exact match only)
      const emailMatch = emails.some(apiEmail => {
        const normalizedApiEmail = apiEmail.toLowerCase().trim();
        const matches = email === normalizedApiEmail;
        
        console.log(`\n🔎 Checking employee: ${employee.personalInfo?.email || employee.email}`);
        console.log(`   - Employee email: "${email}"`);
        console.log(`   - Against API email: "${normalizedApiEmail}"`);
        
        if (matches) {
          console.log(`   ✅ MATCH: Email exact match`);
        } else {
          console.log(`   ❌ NO MATCH`);
        }
        
        return matches;
      });
      
      if (emailMatch) {
        console.log(`   🗑️  Employee will be REMOVED: ${employee.personalInfo?.email || employee.email} (ID: ${employee._id})`);
      }
      
      return emailMatch;
    };
    
    // First pass: identify all employees to remove from selectedOptions
    console.log('\n🔍 First pass: Checking selectedOptions for matches...');
    const employeesToRemove = selectedOptions.filter(emp => shouldRemoveEmployee(emp));
    const idsToRemove = new Set(employeesToRemove.map(emp => emp._id));
    
    // Also check filteredDepData for any matches
    console.log('\n🔍 Second pass: Checking filteredDepData for matches...');
    const depEmployeesToRemove = filteredDepData.filter(emp => shouldRemoveEmployee(emp));
    depEmployeesToRemove.forEach(emp => idsToRemove.add(emp._id));
    
    const idsToRemoveArray = Array.from(idsToRemove);
    
    // Debug: Show all IDs in selectedOptions
    const allSelectedIds = selectedOptions.map(emp => emp._id);
    console.log('\n🔍 Debug - All IDs in selectedOptions:', allSelectedIds);
    console.log('🔍 Debug - IDs that should be removed:', idsToRemoveArray);
    const foundIds = idsToRemoveArray.filter(id => allSelectedIds.includes(id));
    const missingIds = idsToRemoveArray.filter(id => !allSelectedIds.includes(id));
    console.log('🔍 Debug - Found in selectedOptions:', foundIds);
    console.log('🔍 Debug - Missing from selectedOptions:', missingIds);
    
    console.log(`\n📊 Summary:`);
    console.log(`   - Employees to remove from selectedOptions: ${employeesToRemove.length}`);
    console.log(`   - Employees to remove from filteredDepData: ${depEmployeesToRemove.length}`);
    console.log(`   - Total unique IDs to remove: ${idsToRemoveArray.length}`);
    console.log(`   - IDs to remove:`, idsToRemoveArray);
    console.log(`   - Employees being removed:`, employeesToRemove.map(emp => ({
      _id: emp._id,
      email: emp.personalInfo?.email || emp.email,
      fullName: `${emp.personalInfo?.firstName || ''} ${emp.personalInfo?.surName || emp.personalInfo?.lastName || ''}`.trim()
    })));
    
    if (idsToRemoveArray.length === 0) {
      console.error('⚠️ WARNING: No employees matched for removal!');
      console.log('   - Check if employee data structure matches expected format');
      console.log('   - Verify employee emails are populated correctly');
      console.log('   - Check if emails from API match employee emails exactly');
    }
    
    // Add removed employee IDs to deleted set
    setDeletedEmployeeIds(prev => {
      const newSet = new Set(prev);
      idsToRemoveArray.forEach(id => newSet.add(id));
      console.log(`\n🗑️  Updating deletedEmployeeIds:`, Array.from(newSet));
      return newSet;
    });
    
    // Filter using the IDs we collected (more reliable than calling function again)
    const updatedOptions = selectedOptions.filter(emp => !idsToRemove.has(emp._id));
    console.log(`\n📝 Updated selectedOptions:`);
    console.log(`   - Before: ${selectedOptions.length} employees`);
    console.log(`   - After: ${updatedOptions.length} employees`);
    console.log(`   - Removed: ${selectedOptions.length - updatedOptions.length} employees`);
    console.log(`   - Remaining emails:`, updatedOptions.map(emp => emp.personalInfo?.email || emp.email));
    setSelectedOptions(updatedOptions);
    
    // Filter filteredDepData using the same IDs
    const updatedDepData = filteredDepData.filter(emp => !idsToRemove.has(emp._id));
    console.log(`\n📝 Updated filteredDepData:`);
    console.log(`   - Before: ${filteredDepData.length} employees`);
    console.log(`   - After: ${updatedDepData.length} employees`);
    console.log(`   - Removed: ${filteredDepData.length - updatedDepData.length} employees`);
    setFilteredDepData(updatedDepData);
    
    console.log(`\n✅ removeEmployeesByName completed`);
  };

  const handleSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      // Filter out employees that were marked for deletion (don't send them to API)
      const validEmployees = selectedOptions.filter(emp => !deletedEmployeeIds.has(emp._id));
      const employeeIds = validEmployees.map((option) => option?._id);
      
      console.log('📤 Submitting payroll:');
      console.log(`   - Total selected: ${selectedOptions.length}`);
      console.log(`   - Deleted (excluded): ${deletedEmployeeIds.size}`);
      console.log(`   - Valid (being sent): ${validEmployees.length}`);
      console.log(`   - Excluded emails:`, selectedOptions
        .filter(emp => deletedEmployeeIds.has(emp._id))
        .map(emp => emp.personalInfo?.email || emp.email));
      
      await submitPayroll(
        dayjs(fromDate).format("YYYY-MM-DD"),
        dayjs(toDate).format("YYYY-MM-DD"),
        frequency,
        payrollName,
        employeeIds,
        paymentMethod,
        department,
        removeEmployeesByName
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleUpdate = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const updatedEmployeeIds = selectedOptions
        .map((option) => option._id)
        .filter((id) => !data.employees.includes(id));

      await handleUpdatePayroll(
        data?._id,
        dayjs(fromDate).format("YYYY-MM-DD"),
        dayjs(toDate).format("YYYY-MM-DD"),
        frequency,
        updatedEmployeeIds,
        paymentMethod,
        department
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const frequencyOptions = [
    { value: "All", label: "Select", disabled: true },
    { value: "Monthly", label: "Monthly" },
    { value: "Weekly", label: "Weekly" },
    { value: "Fortnight", label: "Fortnight" },
  ];

  const paymentMethodOptions = [
    { value: "", label: "Select", disabled: true },
    { value: "All", label: "All" },
    { value: "Cash", label: "Cash" },
    { value: "Cheque", label: "Cheque" },
    { value: "Transfer", label: "Transfer" },
  ];

  const existingEmployees = from === "Edit" ? data?.employeeDetails?.map(emp => emp._id) : [];

  return (
    <Box px="15px" pt="20px">
      <Typography sx={styles.heading}>
        {from === "Edit" ? "Edit Payroll" : "Create Payroll"}
      </Typography>
      <Box>
        <Grid container>
          <Grid item xs={12} sx={styles.card}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  id="autocomplete"
                  multiple
                  options={(employeeData || []).filter(emp => !deletedEmployeeIds.has(emp._id))}
                  disableCloseOnSelect={from !== "edit"}
                  value={selectedOptions}
                  isOptionEqualToValue={(option, value) => option._id === value._id}
                  getOptionLabel={(option) => option?.personalInfo?.email || ""}
                  onInputChange={(event, newInputValue) => {
                    SearchEmployee(newInputValue);
                  }}
                  onChange={(event, newValue) => {
                    handleChange(event, newValue);
                  }}
                  renderOption={(props, option, { selected }) => {
                    const isExisting = existingEmployees.includes(option._id);

                    return (<MenuItem {...props} disabled={isExisting}>
                      <Checkbox checked={selected} sx={{ mr: 1 }} />
                      <ListItemText primary={option?.personalInfo?.email || ""} sx={{ "& .MuiListItemText-primary": { fontSize: "0.9rem" } }} />
                    </MenuItem>);
                  }}
                  renderTags={(value, getTagProps) => {
                    const maxChips = 1;
                    const displayed = value.slice(0, maxChips);
                    const moreCount = value.length - maxChips;
                    return [
                      ...displayed.map((option, index) => {
                        const isExisting = existingEmployees.includes(option._id);

                        return (<Chip key={option._id} label={option?.personalInfo?.email || ""} size="small" onDelete={isExisting ? undefined : getTagProps({ index }).onDelete} sx={{
                          maxWidth: 150,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          m: 0.5,
                          backgroundColor: isExisting ? "#ddd" : "#E5E5E5",
                          color: '#000',
                          "& .MuiChip-label": { fontSize: "0.85rem", padding: "0 8px !important" },
                          "& .MuiChip-deleteIcon": { fontSize: "1rem" },
                        }} {...getTagProps({ index })} title={option?.personalInfo?.email} />);
                      }),
                      moreCount > 0 && (
                        <Chip
                          key="more"
                          label={`+${moreCount} more`}
                          size="small"
                          sx={{
                            m: 0.5,
                            backgroundColor: "#E5E5E5",
                            color: '#000',
                            "& .MuiChip-label": { fontSize: "0.85rem", padding: "0 8px" },
                          }}
                        />
                      ),
                    ];
                  }}
                  renderInput={(params) => (
                    <>
                      <InputLabel sx={styles.label}>Employee Email</InputLabel>
                      <TextField
                        {...params}
                        sx={{
                          ...styles.modalInput,
                          ...styles.inputSpace,
                          "& .MuiInputBase-root": {
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 0.5,
                            padding: "4px 8px",
                            minHeight: "40px",
                          },
                          "& .MuiInputBase-input": {
                            flexGrow: 1,
                            minWidth: 100,
                            width: "auto",
                            fontSize: "0.9rem",
                          },
                          "& input::placeholder": {
                            color: '#C4C4C4',
                            opacity: 1,
                          },
                        }}
                        variant="outlined"
                        placeholder={selectedOptions.length === 0 ? "Select Employees" : ""}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loading && <CircularProgress color="inherit" size={20} />}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    </>
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputLabel sx={styles.label}>Payroll Name</InputLabel>
                <CustomInput
                  name="frequency"
                  editable={from === "Edit"}
                  onChange={(name, value) => {
                    setPayrollName(value);

                    if (!value.trim()) {
                      setPayrollNameError("Payroll name is required");
                    } else if (value.length < 3) {
                      setPayrollNameError("Payroll name must be at least 3 characters");
                    } else {
                      setPayrollNameError("");
                    }
                  }}
                  defaultValue={data?.name}
                  placeholder="Enter Payroll Name"
                  value={payrollName}
                  error={payrollNameError}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} sx={{ mt: 1.3 }}>
                <InputLabel sx={styles.label}>Payroll Frequency</InputLabel>
                <Select
                  value={frequency}
                  onChange={(e) => setFrequency(e.target.value)}
                  sx={{ ...styles.modalInput, borderRadius: "8px", my: "3px" }}
                  displayEmpty
                  disabled={from === "Edit"}
                >
                  <MenuItem disabled value="">
                    Select
                  </MenuItem>
                  {frequencyOptions?.map((item, index) => (
                    <MenuItem key={index} value={item?.value}>
                      {item?.value}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid item xs={12} sm={8}>
                <DemoContainer
                  components={["DatePicker", "DatePicker"]}
                  sx={styles.calender}
                >
                  <Grid container>
                    <Grid item xs={12} sm={6} sx={{ pr: 2 }}>
                      <InputLabel sx={styles.label}>Start Date</InputLabel>
                      <TextField
                        type="date"
                        value={fromDate ? fromDate.format("YYYY-MM-DD") : ""}
                        disabled={from === "Edit"}
                        sx={styles.calenderInput}
                        onChange={(event) => {
                          setFromDate(dayjs(event.target.value));
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InputLabel sx={styles.label}>End Date</InputLabel>
                      <TextField
                        type="date"
                        value={toDate ? toDate.format("YYYY-MM-DD") : ""}
                        disabled={from === "Edit"}
                        sx={styles.calenderInput}
                        inputProps={{
                          min: fromDate ? fromDate.format("YYYY-MM-DD") : "",
                        }}
                        onChange={(event) => {
                          setToDate(dayjs(event.target.value));
                        }}
                      />
                    </Grid>
                  </Grid>
                </DemoContainer>
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ mt: 0.5 }}>
              <Grid item xs={12} md={4}>
                <InputLabel sx={styles.label}>Payment Method</InputLabel>
                <Select
                  value={paymentMethod}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                  sx={{ ...styles.modalInput, borderRadius: "8px", my: "4px" }}
                  displayEmpty
                  disabled={from === "Edit"}
                >
                  {paymentMethodOptions.map((option) => (
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      disabled={option.disabled}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid item xs={12} md={4}>
                <InputLabel sx={styles.label}>Department</InputLabel>
                <Select
                  value={department}
                  onChange={handleDepartmentChange}
                  sx={{ ...styles.modalInput, borderRadius: "8px", my: "4px" }}
                  displayEmpty
                  disabled={from === "Edit"}
                >
                  <MenuItem disabled value="">
                    Select
                  </MenuItem>

                  {[{ name: "All" }, ...(departmentData || [])].map((item, index) => (
                    <MenuItem
                      key={index}
                      value={item?.name}
                      onClick={() => DepartmentPayroll(item?.name)}
                    >
                      {item?.name}
                    </MenuItem>
                  ))}
                </Select>

              </Grid>
            </Grid>

            <Box>
              <LoadingButton
                loading={loading || isSubmitting}
                variant="contained"
                type="button"
                onClick={() =>
                  from === "Edit" ? handleUpdate() : handleSubmit()
                }
                disabled={
                  loading ||
                  isSubmitting ||
                  !payrollName.trim() ||
                  !!payrollNameError ||
                  (from === "Edit" && !isUpdated)
                }
                color="success"
                sx={styles.btn}
              >
                {from === "Edit" ? "Update" : "Create New"}
              </LoadingButton>
            </Box>
          </Grid>
          <PayrollEmployeeList
            data={selectedOptions}
            payrollData={data}
            handleDelete={handleDelete}
            from={from}
            depData={filteredDepData}
            setAllEmp={setAllEmp}
            allEmp={allEmp}
            department={department}
            selectedOptions={selectedOptions}
          />
        </Grid>
      </Box>
    </Box>
  );
}

export default CreatePayrollPage;
